import { ViewStyle } from "react-native";
import { ThemeStyle, ClassGroupType } from "../../Style.types";

export interface IButtonClassGroup {
  btn: ThemeStyle;
  btnPrimary: ThemeStyle;
  btnSecondary: ThemeStyle;
  btnNeutralLighter: ThemeStyle;
  btnNeutralDarker: ThemeStyle;
  btnSuccess: ThemeStyle;
  btnWarning: ThemeStyle;
  btnDanger: ThemeStyle;
  btnInfo: ThemeStyle;
  btnOutlinePrimary: ThemeStyle;
  btnOutlineSecondary: ThemeStyle;
  btnOutlineNeutralLighter: ThemeStyle;
  btnOutlineNeutralDarker: ThemeStyle;
  btnOutlineSuccess: ThemeStyle;
  btnOutlineWarning: ThemeStyle;
  btnOutlineDanger: ThemeStyle;
  btnOutlineInfo: ThemeStyle;
  btnTextPrimary: ThemeStyle;
  btnTextSecondary: ThemeStyle;
  btnTextNeutralLighter: ThemeStyle;
  btnTextNeutralDarker: ThemeStyle;
  btnTextSuccess: ThemeStyle;
  btnTextWarning: ThemeStyle;
  btnTextDanger: ThemeStyle;
  btnTextInfo: ThemeStyle;
  btnXSmall: ThemeStyle;
  btnSmall: ThemeStyle;
  btnMedium: ThemeStyle;
  btnLarge: ThemeStyle;
  btnDisabled: ThemeStyle;
  btnOutlineDisabled: ThemeStyle;
  btnTextDisabled: ThemeStyle;
  btnBlock: ViewStyle;
}

export const ButtonClassGroup: ClassGroupType<IButtonClassGroup> = {
  btn: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    flexDirection: "row",
    alignSelf: "flex-start",
    alignItems: "center",
    position: "relative",
    gap: theme.fonts.baseSize * 0.5,
  }),
  btnBlock: {
    alignSelf: "stretch",
    justifyContent: "center",
  },
  btnPrimary: (theme) => ({
    backgroundColor: theme.colors.primary.main,
    color: theme.colors.primary.contrast,
  }),
  btnSecondary: (theme) => ({
    backgroundColor: theme.colors.secondary.main,
    color: theme.colors.secondary.contrast,
  }),
  btnNeutralLighter: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.contrast,
  }),
  btnNeutralDarker: (theme) => ({
    backgroundColor: theme.colors.neutralDarker.main,
    color: theme.colors.neutralDarker.contrast,
  }),
  btnSuccess: (theme) => ({
    backgroundColor: theme.colors.success.main,
    color: theme.colors.success.contrast,
  }),
  btnWarning: (theme) => ({
    backgroundColor: theme.colors.warning.main,
    color: theme.colors.warning.contrast,
  }),
  btnDanger: (theme) => ({
    backgroundColor: theme.colors.danger.main,
    color: theme.colors.danger.contrast,
  }),
  btnInfo: (theme) => ({
    backgroundColor: theme.colors.info.main,
    color: theme.colors.info.contrast,
  }),
  btnTextPrimary: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.primary.main,
  }),
  btnTextSecondary: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.secondary.main,
  }),
  btnTextNeutralLighter: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralLighter.main,
  }),
  btnTextNeutralDarker: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralDarker.main,
  }),
  btnTextSuccess: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.success.main,
  }),
  btnTextWarning: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.warning.main,
  }),
  btnTextDanger: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.danger.main,
  }),
  btnTextInfo: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.info.main,
  }),
  btnDisabled: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.dark,
    color: theme.colors.neutralDarker.light,
  }),
  btnOutlineDisabled: (theme) => ({
    backgroundColor: "transparent",
    borderColor: theme.colors.neutralLighter.dark,
    color: theme.colors.neutralLighter.dark,
  }),
  btnTextDisabled: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralDarker.light,
  }),
  btnXSmall: (theme) => ({
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: theme.fonts.baseSize * 0.875,
    borderRadius: 8,
  }),

  btnSmall: (theme) => ({
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: theme.fonts.baseSize,
    borderRadius: 8,
  }),
  btnMedium: (theme) => ({
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: theme.fonts.baseSize,
    borderRadius: 8,
  }),
  btnLarge: (theme) => ({
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: theme.fonts.baseSize * 1.125,
    borderRadius: 8,
  }),
  btnOutlinePrimary: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.primary.main,
    color: theme.colors.primary.main,
  }),
  btnOutlineSecondary: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.secondary.main,
    color: theme.colors.secondary.main,
  }),
  btnOutlineNeutralLighter: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.main,
  }),
  btnOutlineNeutralDarker: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.neutralDarker.main,
    color: theme.colors.neutralDarker.main,
  }),
  btnOutlineSuccess: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.success.main,
    color: theme.colors.success.main,
  }),
  btnOutlineWarning: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.warning.main,
    color: theme.colors.warning.main,
  }),
  btnOutlineDanger: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.danger.main,
    color: theme.colors.danger.main,
  }),
  btnOutlineInfo: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.info.main,
    color: theme.colors.info.main,
  }),
};
